import _ from 'lodash'
import React, { useEffect, useState } from "react"
import { findDOMNode } from 'react-dom';
import notificationService from "data/notification";
import * as channels from "data/websocket/sharedChannel"
import { CircularProgressbar } from "react-circular-progressbar"


export function subscribe(channel, cb) {
  const ch = channels[channel + 'Channel']
  const Content = ({initialMessage}) => {
    const [message, setMessage] = useState('')
    useEffect(() => {
      setMessage(initialMessage)
      const handler = (event) => {
        const unsubscribe = () => {
          // const el = findDOMNode(toast.current) as Element
          // const btn = el.querySelector('button')
          // btn?.click()
          // ch.offEvent(handler)
        }
        cb(event, setMessage, unsubscribe)
      }
      ch.onEvent(handler)
    }, [])

    return <span>{message}</span>
  }

  return Content
}

export function progress(channel, cb) {
  const ch = channels[channel + 'Channel']
  const ctx = {}
  const Content = ({correlationid, initialMessage}) => {
    const [progress, setProgress] = useState(0)
    _.set(ctx, 'progress', progress)
    useEffect(() => {
      const handler = (event) => {
        const unsubscribe = () => {
          notificationService.dequeue(correlationid)
          ch.offEvent(handler)
        }
        cb(event, setProgress, unsubscribe, ctx)
      }
      ch.onEvent(handler)
    }, [ch])

    return <span><CircularProgressbar value={progress} styles={{root:{width: '14px', margin: 'auto 5px 2px -5px'}}} key={correlationid}/>{initialMessage}</span>
  }

  return Content
}
